import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';

/**
 * The footer inside the signed-in app.
 *
 * The legal pages exist and have always been linked — but only from the
 * landing page's own footer, which no signed-in page renders. So a member who
 * arrives, signs in and stays inside the app never sees a route to the terms
 * they are bound by, the privacy policy covering the data being collected, or
 * the refund policy governing the money. A review of the live site concluded
 * the documents did not exist at all, which is what unreachable amounts to in
 * practice.
 *
 * They belong here for the same reason they belong on the landing page: a
 * merchant-of-record review looks for them, and someone deciding whether to
 * dispute a charge looks for them.
 */
const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col sm={6}>
                            {new Date().getFullYear()} © ForecastNest.
                        </Col>
                        <Col sm={6}>
                            {/* The same destinations the marketing footer
                                offers, minus the ones the sidebar already
                                carries. A member inside the app should not have
                                to sign out to reach the terms they are bound by
                                or the page explaining how their forecasts are
                                scored. */}
                            <div className="text-sm-end">
                                <Link to="/research" className="text-muted me-3">
                                    Shared research
                                </Link>
                                <Link to="/how-scoring-works" className="text-muted me-3">
                                    How scoring works
                                </Link>
                                {/* A plain anchor, not a Link: the blog is a separate
                                    subdomain, and react-router would try to match it as
                                    an in-app route and land on the catch-all instead. */}
                                <a href="https://insights.forecastnest.com/" className="text-muted me-3">
                                    Insights
                                </a>
                                <Link to="/terms-condition" className="text-muted me-3">
                                    Terms
                                </Link>
                                <Link to="/privacy-policy" className="text-muted me-3">
                                    Privacy
                                </Link>
                                <Link to="/pricing" className="text-muted me-3">
                                    Pricing
                                </Link>
                                <Link to="/refund-policy" className="text-muted">
                                    Cancellation
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;
